<template>
  <div style="min-height: 250px">
    <div v-if="urlDocument">
      {{ $storeUm6p.Label.Annexes.VeuillezTelecharger }}
      <a target="_blank" :href="urlDocument">
        {{ $storeUm6p.Label.Annexes.CeDocument }}
      </a>
      {{ $storeUm6p.Label.Annexes.SignerDeposer }} : <br />
      <upload-btn
        class="mr-10"
        color="ecSecondary"
        :loading="uploadFileLoading"
        :selectedFileName="
          $storeBourse.DonneesFormulaireEC.publipostageSigne.nomFichier
        "
        :defaultButtonText="$storeUm6p.Label.Annexes.SelectionnerDocument"
        ref="btnupload"
        @file-update="selectFile"
        :acceptFormats="['pdf']"
      >
      </upload-btn>
      <small>{{ $storeUm6p.Label.Annexes.FormatsAcceptesPdf }}</small>
      <br />
      <small>{{ $storeUm6p.Label.Annexes.TailleMaximale }}</small>

      <v-snackbar
        :timeout="2000"
        color="error"
        elevation="24"
        v-model="snackbar"
      >
        {{ $storeUm6p.Label.Annexes.TailleMaximaleDepassee }}
      </v-snackbar>
      <br />
      <v-btn
        large
        dark
        color="ecSecondary"
        v-show="
          $storeBourse.DonneesFormulaireEC.publipostageSigne.nomFichier &&
          !$storeBourse.DonneesFormulaireEC.readOnly
        "
        @click="Valider()"
      >
        VALIDER
      </v-btn>
    </div>
  </div>
</template>
<script>
import UploadButton from "@/components/CustomFileUpload";
export default {
  components: {
    "upload-btn": UploadButton,
  },
  data() {
    return {
      $storeBourse: this.$storeBourse,
      $storeUm6p: this.$storeUm6p,
      uploadFileLoading: false,
      snackbar: false,
      urlDocument: "",
      token: ""
    };
  },
  mounted()
  {
    let token = this.$route.query.t;
    if (token) {
      this.token = token.replace(/\s/g, "+");
      this.$storeBourse.AffecteToken(this.token);
    }
  },
  computed: {},
  methods: {
    async Valider() {
      if (
        !this.$storeBourse.DonneesFormulaireEC.publipostageSigne
          .donneePieceJointe
      ) {
        let erreur = ["Veuillez ajouter le résumé signé"];
        this.$storeBourse.AfficherListeErreurs(erreur);
        return;
      }

      const valide = await this.$storeBourse.Signer(
        this.$storeCatalogue.DataId.CandidatureBourseFirsiSoumis,
        this.token
      );
      if (valide) {
        this.urlDocument = "";
      }
    },
    async Publiposter(token) {
      this.urlDocument = await this.$storeBourse.Publiposter(token);
      this.$storeBourse.DonneesFormulaireEC.lienDocument = this.urlDocument;
    },
    // Fonction appelé quand un fichier sélectionné ou déselectionné dans le 'upload-btn'
    async selectFile(file) {
      if (file) {
        if (file.size / 1024 > 8000) {
          this.$storeBourse.DonneesFormulaireEC.publipostageSigne.nomFichier =
            "";
          this.$storeBourse.DonneesFormulaireEC.publipostageSigne.donneePieceJointe =
            null;
          this.snackbar = true;
        } else {
          this.uploadFileLoading = true;
          this.$storeBourse.DonneesFormulaireEC.publipostageSigne.nomFichier =
            file.name;
          await this.readFile(
            file,
            this.$storeBourse.DonneesFormulaireEC.publipostageSigne
          );
          setTimeout(this.stopLoadinMode, 2000);
        }
      } else {
        this.$storeBourse.DonneesFormulaireEC.publipostageSigne.nomFichier = "";
        this.$storeBourse.DonneesFormulaireEC.publipostageSigne.donneePieceJointe =
          null;
      }
    },
    // Lire le contenu d'un fichier la data de l'élément en cours
    readFile(file, monFichier) {
      var reader = new FileReader();

      // Listener de fin de lecture
      reader.onloadend = function () {
        // Recupérer la chaine lise dans le data de l'élément en cours
        monFichier.donneePieceJointe = btoa(reader.result);
      };

      // Lancer la lecture du ficheir
      reader.readAsBinaryString(file);
    },

    // Arrêter
    stopLoadinMode() {
      this.uploadFileLoading = false;
    },
  },
};
</script>
